import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

// users
// import user1 from "../../../assets/images/users/avatar-1.jpg"

import { connect } from "react-redux"
import api from "helpers/Api"

const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj
  }
}

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "Admin",
      profileImage: "",
      defaultImage: "",
      // salesLeadLength: "",
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }))
  }

  componentDidMount() {
    const userData = getUserName()
    // console.log(userData, "userData")
    if (userData) {
      // api.post("cronTestsalesLead", { status: "active" }).then((res) => {
      //   localStorage.setItem(res.data, "cronLength")
      //   this.setState({
      //     salesLeadLength: res.data.data.length,
      //   })
      //   res.data
      //   console.log(res.data.data.length, "response from profileMenu")
      // })
      this.setState({
        name: userData.name,
        profileImage: userData.profileImage,
        defaultImage: userData.defaultImage,
      })
    }
    // console.log(this.state, "state values")
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      const userData = getUserName()
      if (userData) {
        // api.post("cronTestsalesLead", { status: "active" }).then((res) => {
        //   localStorage.setItem(res.data, "cronLength")
        //   this.setState({
        //     salesLeadLength: res.data.data.length,
        //   })
        //   res.data
        //   console.log(res.data.data.length, "response from profileMenu")
        // })
        this.setState({
          name: userData.name,
          profileImage: userData.profileImage,
          defaultImage: userData.defaultImage,
        })
        // console.log(this.state, "state values")
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={this.state.profileImage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = this.state.defaultImage
              }}
            />{" "}
            <span className="d-none d-md-inline-block ms-1">
              {this.state.name}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a">
              <Link to="/my-profile">
                <i className="bx bx-wrench font-size-16 align-middle me-1" />
                <span>{this.props.t("Profile")}</span>
              </Link>
            </DropdownItem>
            <DropdownItem tag="a" href="#">
              {/* <span className="badge bg-success float-end">
                {this.state.salesLeadLength}
              </span> */}
              <i className="bx bx-wrench font-size-17 align-middle me-1" />
              {this.props.t("Settings")}
            </DropdownItem>
            <div className="dropdown-divider" />
            <Link to="/logout" o className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span
                onClick={() => {
                  api
                    .get(
                      "/logout?oneSignalDeviceId=dee3045e-ab6f-4f90-8c7f-e6314944f25e"
                    )
                    .then((res) => {
                      // console.log(res.data, "response")
                      res.data
                    })
                    .catch((error) => Promise.reject(error))
                }}
              >
                {this.props.t("Logout")}
              </span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.any,
  dispatch: PropTypes.any,
}

const mapStateToProps = (state) => {
  const { success } = state.session
  return { success }
}

export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu))
)
